import { Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { RequireAuth } from './auth/RequireAuth'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { IntegratorsPage } from './pages/IntegratorsPage'
import { IntegratorDetailPage } from './pages/IntegratorDetailPage'
import { MerchantsPage } from './pages/MerchantsPage'
import { MerchantDetailPage } from './pages/MerchantDetailPage'
import { InvoicesPage } from './pages/InvoicesPage'
import { InvoiceDetailPage } from './pages/InvoiceDetailPage'
import { CallbacksPage } from './pages/CallbacksPage'
import { CallbackDetailPage } from './pages/CallbackDetailPage'

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/integrators" element={<IntegratorsPage />} />
        <Route path="/integrators/:integratorId" element={<IntegratorDetailPage />} />
        <Route path="/integrators/:integratorId/merchants" element={<MerchantsPage />} />
        <Route path="/merchants" element={<MerchantsPage />} />
        <Route path="/merchants/:merchantId" element={<MerchantDetailPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/invoices/:invoiceId" element={<InvoiceDetailPage />} />
        <Route path="/callbacks" element={<CallbacksPage />} />
        <Route path="/callbacks/:callbackId" element={<CallbackDetailPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
